import { render } from "./IconButton.vue?vue&type=template&id=0cac2d01&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=0cac2d01&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.17.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cac2d01"]])

export default __exports__